export enum CombiLineRole {
  None = 0,
  Component = 1,
  Adjustment = 2,
  ItemSurcharge = 3,
  VariantSurcharge = 4,
  Supplement = 5,
}
